/**
 * Transfer Subscription ActionTypes
 */
export enum Actions {
  UPDATE_TRANSFER_SUBSCRIPTION_INPUT = "UPDATE_TRANSFER_INPUT",
  UPDATE_RADIO_GROUP = "UPDATE_RADIO_GROUP",
  UPDATE_SELECT_VALUE = "UPDATE_SELECT_VALUE",
  SET_TRANSFER_SUBSCRIPTION_INPUT_DIRTY = "SET_TRANSFER_INPUT_DIRTY",
  SWITCH_TRANSFER_SUBSCRIPTION_VALIDITY = "SWITCH_TRANSFER_VALIDITY",
  SET_TRANSFER_SUBSCRIPTION_TOKEN = "SET_TRANSFER_TOKEN",
  SET_BANK_LIST_ITEMS = "SET_BANK_LIST_ITEMS",
  DISABLE_TRANSFER_SUBSCRIPTION_FORM = "DISABLE_TRANSFER_FORM",
  SET_TRANSFER_SUBSCRIPTION_COLOMBIA = "SET_TRANSFER_SUBSCRIPTION_COLOMBIA",
  SET_CONFRONTA_QUESTIONS = "SET_CONFRONTA_QUESTIONS",
  SET_CONFRONTA_ERROR = "SET_CONFRONTA_ERROR",
  DISABLE_SECURE_VALIDATION_ERROR = "DISABLE_SECURE_VALIDATION_ERROR",
  WAIT_RESPONSE = "WAIT_RESPONSE",
  NOT_WAIT_RESPONSE = "NOT_WAIT_RESPONSE",
}



// WEBPACK FOOTER //
// ./src/containers/TransferSubscriptions/store/Actions.ts